import { Injectable, WritableSignal, signal } from '@angular/core';

import { RoutingRoute } from '@models/routing.model';
import { Language } from '@models/language.model';

@Injectable({
  providedIn: 'root',
})
export class Globals {
  public date: Date = new Date();
  public year: string = this.date.getFullYear().toString();
  public routes: WritableSignal<RoutingRoute> = signal({});
  public protocol: 'http://' | 'https://' = 'https://';
  public language: WritableSignal<Language> = signal('cs');
  public regex: any = {
    phone: new RegExp('^[0-9]{5,9}$'),
  };
  public defaultPhoneCode: { cs: string; sk: string; pl: string } = { cs: '+420', sk: '+421', pl: '+48' };
  public photoCacheVersion: number = new Date(new Date().setMinutes(0, 0, 0)).getTime() / 1000;
  public strapiUploadUrl: string = 'https://admin.mototechna.cz';
}
